import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PropTypes from 'prop-types';

export const FilterToolbar = ({ filters, onFilterChange }) => {
  const [assetActiveStatus, setAssetActiveStatus] = useState(null);

  const handleActiveStatusClick = (event) => {
    setAssetActiveStatus(event.currentTarget);
  };

  const handleClose = () => {
    setAssetActiveStatus(null);
  };

  const toggleAssetActiveStatusFilter = (status) => {
    const currentStatuses = Array.isArray(filters.assetActiveStatus) ? filters.assetActiveStatus : [];

    const newStatuses = currentStatuses.includes(status)
      ? currentStatuses.filter((s) => s !== status)
      : [...currentStatuses, status];

    onFilterChange({
      ...filters,
      assetActiveStatus: newStatuses
    });
  };

  const clearAllFilters = () => {
    onFilterChange({
      ...filters,
      assetActiveStatus: []
    });
  };

  const hasActiveFilters = filters?.assetActiveStatus?.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '8px 0'
      }}
    >
      {/* Active Status Filter */}
      <Button
        id="asset-active-status-button"
        aria-controls={assetActiveStatus ? 'asset-active-status-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={assetActiveStatus ? 'true' : undefined}
        onClick={handleActiveStatusClick}
        endIcon={<KeyboardArrowDownIcon />}
        variant={filters.assetActiveStatus?.length > 0 ? 'contained' : 'outlined'}
        size="small"
      >
        Active Status ({filters?.assetActiveStatus?.length})
      </Button>
      <Menu
        id="asset-active-status-menu"
        anchorEl={assetActiveStatus}
        open={Boolean(assetActiveStatus)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => toggleAssetActiveStatusFilter('Active')}
          selected={filters.assetActiveStatus?.includes('Active')}
        >
          Active
        </MenuItem>
        <MenuItem
          onClick={() => toggleAssetActiveStatusFilter('Inactive')}
          selected={filters.assetActiveStatus?.includes('Inactive')}
        >
          Inactive
        </MenuItem>
      </Menu>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <Button onClick={clearAllFilters} size="small" color="secondary">
          Clear All
        </Button>
      )}

      {/* Active Filters Display */}
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {filters?.assetActiveStatus?.map((status) => (
          <Chip
            key={`asset-active-${status}`}
            label={`Active: ${status}`}
            onDelete={() => toggleAssetActiveStatusFilter(status)}
            size="small"
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
};

FilterToolbar.propTypes = {
  filters: PropTypes.any,
  onFilterChange: PropTypes.any
};
